import styled, { createGlobalStyle } from "styled-components";
import fontBoltsSfRegular from "../../assets/fonts/bolts.sf.regular.ttf";

export const GlobalStyle = createGlobalStyle`
  body {
    min-width: 100%;
    min-height: 100vh;
    font-family: "Roboto";
  }

  @font-face {
    font-family: "Bolts SF Regular";
    src: url(${fontBoltsSfRegular}) format("truetype");
    font-weight: normal;
  }
`;

export const Emphasize = styled.span`
  color: #dc0100;
`;

export const StrikeOut = styled.span`
  text-decoration: line-through;
  font-weight: normal;
`